import React from 'react';
import { Helmet } from 'react-helmet';
import { Link } from 'react-router-dom';
import { COMPARISONS } from './Vs';

const Comparatifs = () => (
    <div className="min-h-screen bg-slate-200 pt-16">
        <Helmet>
            <title>Comparatifs — CV Analyse vs Jobscan, Resume Worded, Canva</title>
            <meta
                name="description"
                content="Différences entre CV Analyse et Jobscan, Resume Worded ou Canva : langue, ATS, tarif, usage."
            />
            <link rel="canonical" href="https://www.cv-analyse.fr/comparatifs" />
        </Helmet>

        <div className="bg-slate-900 text-white">
            <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
                <h1 className="text-3xl md:text-4xl font-semibold mb-3">Comparatifs</h1>
                <p className="text-slate-300 leading-relaxed">
                    CV Analyse note un CV français. Voici en quoi ça diffère des outils US de matching ATS et des modèles Canva.
                </p>
            </div>
        </div>

        <div className="max-w-3xl mx-auto px-4 sm:px-6 py-10 space-y-4">
            {Object.entries(COMPARISONS).map(([slug, item]) => (
                <Link key={slug} to={`/vs/${slug}`} className="card-surface p-6 block hover:border-blue-400">
                    <h2 className="text-lg font-semibold text-slate-900 mb-2">{item.title}</h2>
                    <p className="text-sm text-slate-600 leading-relaxed">{item.description}</p>
                    <span className="text-sm font-medium text-blue-700 mt-3 inline-block">Lire le comparatif →</span>
                </Link>
            ))}
            <p className="text-sm text-slate-500 pt-2">
                Méthode de calcul : <Link to="/methode" className="text-blue-700">5 critères, moyenne /100</Link>
                {' · '}
                <Link to="/barometre" className="text-blue-700">Baromètre des scores</Link>
            </p>
        </div>
    </div>
);

export default Comparatifs;
